<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号/实体卡号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
        <el-button @click="handleAddCard" type="success">绑定实体卡</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="会员">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.wxheadurl" />
                </div>
                <div v-if="scope.row.name!==''" class="pay-member-name">{{ scope.row.name }}<br />ID：{{ scope.row.mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.wxname }}<br />ID：{{ scope.row.mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.mobile }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="实体卡号">
              <template slot-scope="scope">
                <span>{{ scope.row.cardno }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime }} </span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page"  :total="total">
      </el-pagination>
      <card-modal ref="modalAddCard" @ok="modalWithholdOk"></card-modal>
    </el-container>
  </el-container>
</template>
<script>
import { memberSearchCardList } from '@/views/webpc/CashierDesk/CardManagementApp/apis'
import CardModal from './modules/CardModal'
export default {
  components: { CardModal },
  data () {
    return {
      pageSize: 20,
      page: 1,
      total: 0,
      valueid: '',
      tableData: []
    }
  },
  methods: {
    // 绑定实体卡
    handleAddCard () {
      this.$refs.modalAddCard.show()
    },
    // 绑定实体卡
    modalWithholdOk () {
      this.loadData()
    },
    // 验证记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      memberSearchCardList(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  created () {
    // let shop = window.location.hostname.split('.')[0]
    // if (shop === 'localhost') {
    //   this.$router.push('/cardManagementAnother')
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CardManagementApp/CardManagement.vue